
import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  EventEmitter,
  Output
}                       from '@angular/core';

import { ActionService         } from "@/services/action.service";

import {ContrastResetAction} from "@/components/krpano/actions/contrast.reset.action";


@Component({
  standalone: false,
  selector:    'pano-contrast',
  template: `
    <div class="knob-wrapper">
      <p-knob
        id="contrast-knob"
        [(ngModel)]="_contrast"
        [size]="140"
        [min]="0"
        [max]="200"
        [step]="1"
        valueTemplate="{{percent()}}%"
        textColor="white"
        [valueColor]="strokeColor"
        (onChange)="onChange()">
      </p-knob>
      <div class="knob-icon"><img (click)="reset()" src="/assets/images/contrast-24.png"></div>
    </div>`

})

/**
 *
 * @class PanoramaContrastComponent
 *
 * @brief contrast filter on top of the panoramic viewer
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class PanoramaContrastComponent implements OnInit, OnDestroy, AfterViewInit {

  public min: number         = 0.0;
  public max: number         = 200;
  public _contrast: number = 100;
  public strokeColor: string = 'rgba(41, 170, 226, 0.38)';

  @Output() contrast_event = new EventEmitter<number>();

  constructor(
    private actions: ActionService
  ) {

    this.actions.add(new ContrastResetAction(this));
  }

  ngOnInit() {


  }

  percent(): number {

    return Math.round(this._contrast);
  }

  /** fetch the css contrast filter value (0.0 - 2.0) */
  contrast(): number {

    return this._contrast / 100.0;
  }

  reset() {

    this._contrast = 100;
    this.onChange()
  }

  ngOnDestroy() {

  }

  ngAfterViewInit() {

  }

  onChange() {

    this.contrast_event.emit(this.contrast());
  }
}
